import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Pages/Home';
//import { Default } from './components/Pages/Default';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { ContactUs } from './components/ContactUs';

import { library, config } from '@fortawesome/fontawesome-svg-core'
// https://fontawesome.com/how-to-use/with-the-api/setup/library
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIgloo } from '@fortawesome/free-solid-svg-icons'
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faAd } from '@fortawesome/free-solid-svg-icons';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
//import { faFacebookOfficial } from '@fortawesome/free-brands-svg-icons';
// https://fontawesome.com/icons?d=gallery&s=brands&m=free
//import { faFacebook  } from '@fortawesome/free-brands-svg-icons';
//import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
//import { faFacebookSquare  } from '@fortawesome/free-brands-svg-icons';
//import { faTwitter } from '@fortawesome/free-brands-svg-icons';
//import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';

import { fab } from '@fortawesome/free-brands-svg-icons';

import './styles/app.scss'; // // Tell Webpack that App.js uses these styles

//config.autoAddCss = false;
library.add(faIgloo);
library.add(faPhoneSquare, faMapMarkerAlt, faEnvelope);
library.add(faAd, faHashtag); // Delete this
library.add(fab)

export default class App extends Component {
    static displayName = App.name;
        
    render() {
        return (
            <Layout>
                <Route exact path='/' component={Home} />
                {/*<Route path='/default' component={Default} />*/}
                <Route path='/counter' component={Counter} />
                <Route path='/fetch-data' component={FetchData} />
                <Route path='/contact-us' component={ContactUs} />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js